import RoadMapSelectSlice from "../features/RoadMapSelectSlice";

const { configureStore } = require("@reduxjs/toolkit");

export const store = configureStore({
    reducer : {
        RoadMapSelect : RoadMapSelectSlice
    },
})